<app-banner [heading]="'FREQUENTLY ASKED QUESTIONS'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>



<section id="faq"  >
  <div class="container">
    <header class="section-header">
      <h3>Frequently Asked Questions</h3>
      <p>Please go thru our FAQ's. Please book your appointment with our guidance counselor    </p>
    </header>

    <ul id="faq-list"  >
      <li>
        <a data-bs-toggle="collapse" class="collapsed" href="#faq1" aria-expanded="false">Q.1. Tagore Global School, Kurukshetra is affiliated to which board?<i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq1" class="collapse" data-parent="#faq-list" >
          <p>
            Ans. The school is affiliated with  CBSE (Affiliation No. 531905). 
          </p>
        </div>
      </li>

      <li>
        <a data-bs-toggle="collapse" href="#faq2" class="collapsed">Q.2. How far is your school from Delhi?<i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq2" class="collapse" data-parent="#faq-list">
          <p>
            Ans. 160 km (approx.)
          </p>
        </div>
      </li>
  <li>
        <a data-bs-toggle="collapse" href="#faq3" class="collapsed">Q.3. What is the school motto? <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq3" class="collapse" data-parent="#faq-list">
          <p>
           Ans. ‘Achieve high Standards’ is the fundamental aim of TGS Kurukshetra i.e. in  Academic /Sports/Intra Co-curricular Activity / Moral Values to keep striving to reach the highest benchmark.
          </p>
        </div>
      </li>
  <li>
        <a data-bs-toggle="collapse" href="#faq4" class="collapsed">Q.4. When does your academic year begin and end? Do you have any mid-year admissions?<i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq4" class="collapse" data-parent="#faq-list">
          <p>
            Ans. Academic Session starts from April, we are open to mid-year admissions especially for transfer cases subject to availability of seats.
          </p>
        </div>
      </li>
   <li>
        <a data-bs-toggle="collapse" href="#faq5" class="collapsed">Q.5. What is the procedure of admission?<i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq5" class="collapse" data-parent="#faq-list">
          <p>
            Ans. The procedure of admission for Pre-Primary – First come first serve basis till the admission is closed.
 Class 1 to 9 – On the availability of vacant seats.<br>
           +<br>
Results on previous School’s Report Card, SLC, and other documents.

          </p>
        </div>
      </li>
  <li>
        <a data-bs-toggle="collapse" href="#faq6" class="collapsed">Q.6. What is the minimum age at entry-level?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq6" class="collapse" data-parent="#faq-list">
          <p>
            Ans. The age for Pre-Nursery is 2+ years.
          </p>
        </div>
      </li>
  <li>
        <a data-bs-toggle="collapse" href="#faq7" class="collapsed">Q.7. When should interested parents apply for admission?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq7" class="collapse" data-parent="#faq-list">
          <p>
           Ans. The registration begins from 1st November. The admission forms are available online and at the school reception as well.
          </p>
        </div>
      </li>
   <li>
        <a data-bs-toggle="collapse" href="#faq8" class="collapsed">Q.8. Which are the subjects to be studied in Tagore Global School, Kurukshetra from Class 1 to 8?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq8" class="collapse" data-parent="#faq-list">
          <p>
           Ans. Classes 1 to 2: English, Hindi, Maths, Evs, Computer, General Knowledge, Value Education , Reasoning,  Art &amp; Craft, Life Skills <br>
Classes 3 to 4:  English, Hindi, Maths, Science, Social Science, Computer, General Knowledge,  Value Education , Reasoning, Art &amp; Craft, Life Skills <br>
Classes 5 to 8::  English, Hindi, Maths, Science, Social Science, Computer, General Knowledge, Value Education , Reasoning,Art &amp; Craft, Life Skills,  Punjabi/French/Sanskrit

          </p>
        </div>
      </li>
  <li>
        <a data-bs-toggle="collapse" href="#faq9" class="collapsed">Q.9. Which are the subjects to be offered in TGS, Kkr for Class 9 &amp; 10?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq9" class="collapse" data-parent="#faq-list">
          <p>
           Ans. English, Hindi, Maths, Science, Social Science, Artificial intelligence, Punjabi/French/Sanskrit
          </p>
        </div>
      </li>
  <li>
        <a data-bs-toggle="collapse" href="#faq10" class="collapsed">Q.10. What is the academic result?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq10" class="collapse" data-parent="#faq-list">
          <p>
           Ans. Since the inception, the Tagore Group of  Schools’ results have been 100% and almost all students are placed in First Division every year. We are proud to have a legacy of repeatedly producing All India Rankers.
          </p>
        </div>
      </li>
  <li>
        <a data-bs-toggle="collapse" href="#faq11" class="collapsed">Q.11. Is the school working 5 days or 6 days a week?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq11" class="collapse" data-parent="#faq-list">
          <p>
           Ans. The school is working 6 days a week.
          </p>
        </div>
      </li>
  <li>
        <a data-bs-toggle="collapse" href="#faq12" class="collapsed">Q.12. What arrangements do you have for transport? Do you have a door pick-up facility for the children?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq12" class="collapse" data-parent="#faq-list">
          <p>
           Ans. We have a fleet of buses plying for different parts of the city, we have common pick and drop points close to the student’s house,we try to pick and drop the child from as close to the house as possible.
          </p>
        </div>
      </li>
  <li>
        <a data-bs-toggle="collapse" href="#faq13" class="collapsed">Q.13. What is the role of games/yoga/music/dance in the school?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq13" class="collapse" data-parent="#faq-list">
          <p>
           Ans. They are an integral part and are incorporated into the curriculum.
          </p>
        </div>
      </li>
  <li>
        <a data-bs-toggle="collapse" href="#faq14" class="collapsed">Q.14. Does the school offer any hobbies to the students?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq14" class="collapse" data-parent="#faq-list">
          <p>
           Ans. For the development of creativity, one hour daily is assigned for extra-curricular activities. Children are also required to join various clubs as per their interest and talent which are:-<br>
      Dance<br>
      Public Speaking<br>
      Games<br>
      Eco Awareness<br>
      Art &amp; Craft<br>
      Home Science<br>
      Music<br>
      Drama   <br>
      Quiz<br>
      Legal Literacy<br>
      I.T.<br>
      Science<br>
      Vedic maths<br> 
   </p>
        </div>
      </li>
  <li>
        <a data-bs-toggle="collapse" href="#faq15" class="collapsed">Q.15. What extra-curricular activities are done in school?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq15" class="collapse" data-parent="#faq-list">
          <p>
           Ans. All activities for the whole year for classes Pre Nursery to Class 10 are mentioned in the Syllabus Booklet as well on the Website(Activity Calender section).
   </p>
        </div>
      </li>
   <li>
        <a data-bs-toggle="collapse" href="#faq16" class="collapsed">Q.16. When can we meet the Class Teacher or Coordinator?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq16" class="collapse" data-parent="#faq-list">
          <p>
           Ans. They can be met with an appointment through the school office.
   </p>
        </div>
      </li>
  <li>
        <a data-bs-toggle="collapse" href="#faq17" class="collapsed">Q.17. What are your main strengths?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq17" class="collapse" data-parent="#faq-list">
          <p>
           Ans. Our main strength is to treat each child as an independent individual having a set of strengths, talents, affinity, and shortcomings. Our faculty is trained to deal with them with focussed individual attention. We encourage the students to develop curiosity for knowledge and discourage rote learning.
   </p>
        </div>
      </li>
   <li>
        <a data-bs-toggle="collapse" href="#faq18" class="collapsed">Q.18. What are your main achievements?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq18" class="collapse" data-parent="#faq-list">
          <p>
           Ans. TGS, Kkr has earned a niche for itself in the region. We have a reputation for forming a very strong base right from our foundation classes. We are known to be excellent in Academics proven by our Board results every year and are considered to have struck the right balance between academics and extracurricular activities backed by a very efficient, experienced, and dedicated faculty.
   </p>
        </div>
      </li>
  <li>
        <a data-bs-toggle="collapse" href="#faq19" class="collapsed">Q.19. How is TGS, Kkr different from other schools?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq19" class="collapse" data-parent="#faq-list">
          <p>
           Ans. We emphasize creative thinking, logical reasoning, and problem-solving. Rote learning is discouraged. We promote holistic development for a well-shaped personality.
   </p>
        </div>
      </li>
  <li>
        <a data-bs-toggle="collapse" href="#faq20" class="collapsed">Q.20. Does your school follow any specific philosophy different from other regular schools?
  <i class="fa-solid fa-plus"></i><i class="fa-solid fa-minus"></i></a>
        <div id="faq20" class="collapse" data-parent="#faq-list">
          <p>
           Ans. TGS, Kkr, a center of excellence, believes that every child has some innate qualities which can be identified and polished. Stress is laid on the overall development of the child.
   </p>
        </div>
      </li>



      

    </ul>

  </div>
</section>